'use client';
import { useImpersonationOverlay } from '../impersonation/auth-overlay-context.js';
import { useWalletsContext } from './wallets-context.js';
const IMPERSONATED_WALLET_ID_PREFIX = 'impersonated:';
function buildImpersonatedWallets(target) {
    return target.walletAddresses.map((address, index) => ({
        id: `${IMPERSONATED_WALLET_ID_PREFIX}${target.userId}:${String(index)}`,
        address,
        label: index === 0
            ? (target.displayName ?? target.handle ?? 'Primary')
            : `Wallet ${String(index + 1)}`,
        type: 'embedded',
        isAvailable: true,
        isPrimary: index === 0,
        archivedAt: null,
        turnkeySubOrgId: null,
        totalVolume: '0',
        totalTrades: 0,
        realizedPnl: '0',
        unrealizedPnl: '0',
        totalPnl: '0',
        marketsTraded: 0,
        createdAt: '',
    }));
}
/**
 * Returns the current wallets, applying the impersonation overlay when
 * an engineer is impersonating a target user.
 *
 * Drop-in replacement for the old `frontend/src/hooks/auth/use-wallets.ts`.
 * Import from `@morfi/backend-sdk-v2/client`.
 */
export function useWallets(enabled = true) {
    const base = useWalletsContext();
    const { isActive: isImpersonating, target } = useImpersonationOverlay();
    if (!enabled || !isImpersonating || target === null) {
        return base;
    }
    const impersonatedWallets = buildImpersonatedWallets(target);
    return {
        ...base,
        wallets: impersonatedWallets,
        isLoading: false,
        error: null,
    };
}
/** Re-exported from wallets-context — provides archived wallet data.
 *  The frontend wires this via `<ArchivedWalletsProvider>`. */
export { useArchivedWalletsContext as useArchivedWallets } from './wallets-context.js';
//# sourceMappingURL=use-wallets.js.map